export default {
	'items': [
		{
			'year': '2025',
			'name': 'MyOme',
			'link': 'https://myome.com/',
			'tech': ['Nuxt', 'SCSS', 'Vercel'],
			'company': 'HDMZ'
		},
		{
			'year': '2024',
			'name': 'Gilead Research Scholars',
			'link': 'https://researchscholars.gilead.com/',
			'tech': ['Pimcore', 'Stimulus JS', 'Twig', 'Mapbox'],
			'company': 'HDMZ'
		},
		{
			'year': '2024',
			'name': 'Delve Bio',
			'link': 'https://delve.bio/',
			'tech': ['Wordpress', 'ACF', 'PHP', 'JS', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2024',
			'name': 'HDMZ',
			'link': 'https://www.hdmz.com/',
			'tech': ['Drupal', 'Twig', 'Paragraphs Module', 'Webform Module'],
			'company': 'HDMZ'
		},
		{
			'year': '2023',
			'name': 'Repligen',
			'link': 'https://www.repligen.com/',
			'tech': ['Pimcore', 'Stimulus JS', 'Webpack', 'Bootstrap', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2022',
			'name': 'Nutcracker',
			'link': 'https://www.nutcrackerx.com/',
			'tech': ['Wordpress', 'ACF', 'PHP', 'JS', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2022',
			'name': 'BeiGene',
			'link': 'https://www.beigene.com/',
			'tech': ['Wordpress', 'ACF', 'PHP', 'JS', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2021',
			'name': 'Tierrabio Protein Platform',
			'link': 'https://proteinplatform.tierrabiosciences.com/',
			'tech': ['Pimcore', 'Twig/PHP', 'Vue', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2021',
			'name': 'Innoviva',
			'link': 'https://inva.com/',
			'tech': ['Wordpress', 'JS', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2021',
			'name': 'GeneDx',
			'link': 'https://www.genedx.com/',
			'tech': ['Pimcore', 'Twig/PHP', 'JS', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2021',
			'name': 'Clovis',
			'link': 'https://targetedradiotherapy.com/',
			'tech': ['Wordpress', 'ACF', 'PHP', 'JS', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2021',
			'name': 'Cepheid',
			'link': 'https://www.cepheid.com/',
			'tech': ['Pimcore', 'Twig/PHP', 'JS', 'SCSS'],
			'company': 'HDMZ'
		},
		{
			'year': '2020',
			'name': 'myhELO Web App',
			'link': 'https://www.myhelo.com/about/',
			'tech': ['PHP', 'JS', 'CSS'],
			'company': 'myhELO'
		},
		{
			'year': '2020',
			'name': 'myhELO Corp Site',
			'link': 'https://www.myhelo.com/',
			'tech': ['PHP', 'JS', 'CSS'],
			'company': 'myhELO'
		},
		{
			'year': '2019',
			'name': 'US Water Systems',
			'link': 'https://www.uswatersystems.com/',
			'tech': ['Magento 2'],
			'company': 'US Water Systems'
		},
	]
}